<template>
  <div class="about">
    <Header />
    
    <!-- 背景装饰 -->
    <div class="tech-background"></div>
    <div class="grid-overlay"></div>
    
    <div class="container mx-auto px-4 pt-40 pb-20">
      <h1 class="page-title text-4xl md:text-5xl font-bold mb-16 text-center">
        <span class="title-text">关于云</span>
        <div class="title-line"></div>
      </h1>
      
      <!-- 公司简介模块 -->
      <div class="mb-12">
        <div class="glass-card content-card">
          <div class="card-header">
            <h2 class="section-title">
              <i class="fas fa-building mr-3"></i>公司简介
            </h2>
          </div>
          <div class="card-content">
            <p class="content-text">
              chmura云，作为数字经济浪潮中新一代智慧网络服务的领航者，深耕网络通信与云端服务领域，始终秉持"重塑云端连接，赋能万物互联"的核心使命。依托数字中国建设的时代机遇，公司以用户需求为核心导向，深度耕耘chmura云核心业务的同时，前瞻性构建宽带周边全生态矩阵，致力于为个人消费群体、中小微企业、政企客户及重点行业伙伴，提供全场景覆盖、全周期服务、定制化适配的高品质网络综合解决方案，助力各行业实现数字化转型与智能化升级。
            </p>
            <p class="content-text">
              依托前沿的云计算与网络传输技术，chmura云业务打破传统宽带局限，实现了带宽弹性伸缩、智能加速优化、安全防护一体化的核心优势，为用户构建高速、稳定、安全的云端接入通道。立足核心业务，公司前瞻性布局宽带周边生态，积极拓展移动路由设备、物联网卡、智能网关等关联业务，形成"核心业务引领，周边生态赋能"的多元化发展格局，全面覆盖智慧家庭、智能办公、物联网终端连接等多领域场景需求。
            </p>
            <p class="content-text">
              技术创新是chmura云的核心发展引擎。公司汇聚了一批来自网络通信、云计算、物联网、人工智能等领域的顶尖研发人才，组建专业研发团队持续投入技术攻关与产品迭代，建立起完善的研发体系与知识产权布局，多项核心技术获得行业专利认证。凭借过硬的产品品质、精细化的服务体系以及定制化的解决方案能力，chmura云已在多个区域市场树立标杆案例，赢得了政府、企业、家庭用户的广泛认可与信赖。未来，公司将持续深化"云+网+端"全链路生态布局，不断拓展业务边界与服务维度，重点发力工业互联网、智慧政务、智慧医疗等新兴行业领域，深度融入数字经济发展浪潮。同时，公司将积极探索前沿技术与业务的融合应用，以更前沿的技术、更优质的产品、更全面的服务赋能数字经济高质量发展，全力迈向全球领先的智慧网络服务提供商行列，为构建万物互联的智能世界贡献核心力量。
            </p>
          </div>
        </div>
      </div>
      
      <!-- 企业文化模块 -->
      <div>
        <div class="glass-card content-card">
          <div class="card-header">
            <h2 class="section-title">
              <i class="fas fa-lightbulb mr-3"></i>企业文化
            </h2>
          </div>
          <div class="card-content">
            <p class="content-text">
              chmura云深植数字经济蓬勃发展的时代沃土，自创立以来便以"连接智慧未来，赋能万物互联"为初心使命，在深耕智慧网络服务领域、构建"云+网+端"全生态布局的实践中，不断沉淀、凝练，形成了兼具科技属性、行业特质与企业温度的核心文化体系。这一文化体系贯穿企业战略规划、技术研发、市场服务与人才培养的全流程，不仅是凝聚团队共识的精神旗帜，更是驱动企业持续创新、高质量发展的精神内核与行动指南，为企业在激烈的行业竞争中稳步前行提供了坚实的文化支撑。
            </p>
            <p class="content-text">
              <span class="highlight-text">核心价值观：创新引领、客户至上、协同共生、诚信笃行。</span>创新是chmura云的生存之本与发展之源，公司始终将技术创新置于战略核心位置，设立专项研发基金，搭建开放的创新孵化平台，鼓励研发团队突破传统技术边界，积极探索云端智能调度、网络安全防护、物联网融合等前沿技术与网络服务的创新融合点，以迭代升级的核心技术破解行业带宽瓶颈、体验不均等痛点，持续为用户创造全新的网络服务价值。
            </p>
            <p class="content-text">
              客户至上是企业发展的核心导向，chmura云始终坚持以用户需求为出发点和落脚点，建立全流程客户需求响应机制，从前期的需求调研、方案定制，到中期的产品部署、技术调试，再到后期的运维保障、升级优化，全链条践行精细化、个性化服务理念，针对个人家庭、中小微企业、政企客户等不同群体的差异化需求，量身打造高品质的网络解决方案，全力提升客户满意度与忠诚度。
            </p>
            <p class="content-text">
              协同共生彰显企业的生态思维与格局，对内打破部门壁垒，建立跨部门、跨团队的高效协作机制，通过定期沟通会、项目联动等形式凝聚发展合力，让每一位员工都能在协作中发挥最大价值；对外秉持开放共赢的合作理念，主动联动产业链上下游伙伴、行业科研机构与优质服务商，共建资源共享、优势互补的良性产业生态，推动整个智慧网络行业的协同发展。
            </p>
            <p class="content-text">
              诚信笃行是企业立足的根本准则，chmura云始终坚守商业诚信底线，在经营活动中坚持公开、公平、公正的原则，严格遵守行业规范与法律法规，对客户坚守服务承诺，对员工秉持公正透明的管理理念，对社会主动履行企业责任，以负责任的经营态度赢得市场、客户与社会的长期信赖与认可。
            </p>
            <p class="content-text">
              <span class="highlight-text">企业使命：重塑云端连接价值，赋能数字产业升级。</span>在数字经济加速渗透的当下，chmura云立足网络通信与云端服务核心领域，不仅致力于通过技术创新构建高速、稳定、安全、可拓展的智慧网络连接通道，更以技术与服务为核心纽带，深度融入数字经济发展浪潮。
            </p>
            <p class="content-text">
              <span class="highlight-text">企业愿景：成为全球领先的智慧网络服务生态服务商。</span>为实现这一愿景，未来chmura云将持续深化"云+网+端"全链路生态布局，不断拓展业务边界与服务维度，在巩固国内市场优势的基础上，积极探索海外市场机遇。
            </p>
            <p class="content-text">
              <span class="highlight-text">人才理念：聚才赋能，成就成长。</span>chmura云坚信人才是企业发展的第一资源，是驱动创新的核心动力，始终秉持开放、包容、尊重的人才观，广纳网络通信、云计算、物联网、人工智能等领域的顶尖人才与潜力新秀。
            </p>
          </div>
        </div>
      </div>
    </div>
    <Footer />
    <BackToTop />
  </div>
</template>

<script>
import Header from '../components/Header.vue';
import Footer from '../components/Footer.vue';
import BackToTop from '../components/BackToTop.vue';

export default {
  name: 'About',
  components: {
    Header,
    Footer,
    BackToTop
  }
};
</script>

<style scoped>
.about {
  min-height: 100vh;
  position: relative;
  background: linear-gradient(135deg, #0a0e27 0%, #1a1f3a 50%, #0f1428 100%);
  overflow: hidden;
}

/* 科技感背景 */
.tech-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: 
    radial-gradient(ellipse at 20% 30%, rgba(56, 189, 248, 0.15) 0%, transparent 50%),
    radial-gradient(ellipse at 80% 70%, rgba(147, 51, 234, 0.15) 0%, transparent 50%);
  pointer-events: none;
  z-index: 1;
}

.grid-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: 
    linear-gradient(rgba(56, 189, 248, 0.03) 1px, transparent 1px),
    linear-gradient(90deg, rgba(56, 189, 248, 0.03) 1px, transparent 1px);
  background-size: 50px 50px;
  pointer-events: none;
  z-index: 1;
}

.container {
  position: relative;
  z-index: 2;
  max-width: 1200px;
}

/* 页面标题 */
.page-title {
  color: #fff;
  text-shadow: 0 0 20px rgba(56, 189, 248, 0.5);
  animation: titleGlow 3s ease-in-out infinite;
}

.title-text {
  display: inline-block;
  background: linear-gradient(135deg, #38bdf8 0%, #a78bfa 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.title-line {
  width: 80px;
  height: 3px;
  background: linear-gradient(90deg, transparent, #38bdf8, #a78bfa, transparent);
  margin: 16px auto 0;
  border-radius: 2px;
  animation: lineGlow 2s ease-in-out infinite;
}

@keyframes titleGlow {
  0%, 100% { text-shadow: 0 0 20px rgba(56, 189, 248, 0.5); }
  50% { text-shadow: 0 0 30px rgba(56, 189, 248, 0.8), 0 0 40px rgba(147, 51, 234, 0.4); }
}

@keyframes lineGlow {
  0%, 100% { opacity: 0.6; }
  50% { opacity: 1; }
}

/* 玻璃拟态卡片 */
.glass-card {
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  box-shadow: 
    0 8px 32px rgba(0, 0, 0, 0.3),
    inset 0 1px 1px rgba(255, 255, 255, 0.1);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  animation: fadeInUp 0.6s ease-out;
  overflow: hidden;
}

.glass-card:hover {
  transform: translateY(-5px);
  border-color: rgba(56, 189, 248, 0.3);
  box-shadow: 
    0 12px 48px rgba(0, 0, 0, 0.4),
    0 0 30px rgba(56, 189, 248, 0.2),
    inset 0 1px 1px rgba(255, 255, 255, 0.15);
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 卡片头部 */
.card-header {
  padding: 32px 40px 24px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.section-title {
  font-size: 1.75rem;
  font-weight: 600;
  color: #fff;
  display: flex;
  align-items: center;
  position: relative;
  padding-bottom: 12px;
}

.section-title::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 60px;
  height: 3px;
  background: linear-gradient(90deg, #38bdf8, #a78bfa);
  border-radius: 2px;
}

.section-title i {
  background: linear-gradient(135deg, #38bdf8, #a78bfa);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-size: 1.5rem;
}

/* 卡片内容 */
.card-content {
  padding: 32px 40px;
}

.content-text {
  color: rgba(255, 255, 255, 0.85);
  line-height: 2;
  margin-bottom: 24px;
  text-indent: 2em;
  font-size: 1rem;
  letter-spacing: 0.3px;
  transition: all 0.3s ease;
}

.content-text:last-child {
  margin-bottom: 0;
}

.content-text:hover {
  color: rgba(255, 255, 255, 0.95);
  text-shadow: 0 0 10px rgba(56, 189, 248, 0.3);
}

/* 高亮文本 */
.highlight-text {
  color: #38bdf8;
  font-weight: 600;
  text-shadow: 0 0 10px rgba(56, 189, 248, 0.4);
  display: inline-block;
  margin-right: 8px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .about {
    padding-top: 60px;
  }

  .container {
    padding: 0 16px !important;
    padding-top: 32px !important;
    padding-bottom: 32px !important;
  }

  .page-title {
    font-size: 2rem !important;
    margin-bottom: 40px !important;
  }

  .card-header {
    padding: 24px 24px 20px;
  }

  .section-title {
    font-size: 1.5rem;
  }

  .section-title i {
    font-size: 1.25rem;
  }

  .card-content {
    padding: 24px;
  }

  .content-text {
    font-size: 0.95rem;
    line-height: 1.8;
    text-indent: 1.5em;
    margin-bottom: 20px;
  }

  .highlight-text {
    font-size: 0.95rem;
  }
}
</style>
